<template>
  <div class="cart_agree_conts">
    <div class="cart_agree">
      <span class="agree_txt">
        <input
          class="check-all"
          id="allPaymentTermsAgree"
          type="checkbox"
          @change="toggleAll"
          ref="totalRef"
        >
        <!-- S : 20231205 주문결제 내 개인정보 시정 건(문구 수정) -->
        <label for="allPaymentTermsAgree" class="focus">[필수] 전체 동의하기</label>
        <!-- E : 20231205 주문결제 내 개인정보 시정 건(문구 수정) -->
      </span>
      <!-- <a
        data-toggle="collapse"
        class="collapsed btn_view_agree"
        :class="toggleAccordion ? '' : 'collapsed'"
        :aria-expanded="toggleAccordion"
        @click="toggleAccordion = !toggleAccordion"
      >
        <span class="pull-right icon-arr"><span>약관보기</span></span>
      </a> -->
      <!-- 20231205 주문결제 내 개인정보 시정 건(in 클래스 추가) -->
      <div
        id="down20"
        class="panel-collapse applicants-panel collapse in" 
      >
        <div class="applicants-panel-in">
          <div class="cart_agree0">
            <input
              class="login-form-remember"
              id="paymentTermsAgree1"
              name="paymentTermsAgree1"
              type="checkbox"
              :checked="terms[0].checked"
              @change="onCheckBoxChange($event, 0)"
            >
            <label
            for="paymentTermsAgree1"
            class="focus">주문하실 상품의 상품명, 가격, 배송정보를 확인하였으며, 이에 동의(전자상거래법 제8조 제2항)
            </label>
          </div>
          <div class="cart_agree0">
            <input
              class="login-form-remember"
              id="paymentTermsAgree2"
              name="paymentTermsAgree2"
              type="checkbox"
              :checked="terms[1].checked"
              @change="onCheckBoxChange($event, 1)"
            >
            <label
              for="paymentTermsAgree2" class="focus">개인정보 수집 ∙ 이용 동의
            </label>
            <a
              class="title"
              @click="openPopUp(1)"
            >자세히 보기

            </a>
          </div>
        </div>
      </div>

      <div class="toss_agree_box" v-if="isTossTermsRequired">

        <div class="toss_agree_box_inner">
          <span class="agree_txt">
            <input
              class="login-form-remember"
              type="checkbox"
              id="paymentTermsAgree3"
              name="paymentTermsAgree3"
              :checked="terms[2].checked"
              @change="onCheckBoxChange($event, 2)"
            >
            <label for="paymentTermsAgree3" class="focus">TOSS 개인정보 수집 이용 동의
            </label>
          </span>
          <a
            class="title"
            @click="openPopUp(2)"
          >
            자세히 보기
          </a>
        </div>

        <div
          class="toss_agree_box_inner">
          <span class="agree_txt">
            <input
              class="login-form-remember"
              type="checkbox"
              id="paymentTermsAgree4"
              name="paymentTermsAgree4"
              :checked="terms[3].checked"
              @change="onCheckBoxChange($event, 3)"
            >
            <label for="paymentTermsAgree4" class="focus">TOSS 전자금융거래 기본약관</label>
          </span>
          <a
            class="title"
            @click="openPopUp(3)"
          >
            자세히 보기
          </a>
        </div>

        <div class="toss_agree_box_inner">
          <span class="agree_txt">
            <input
              class="login-form-remember"
              type="checkbox"
              id="paymentTermsAgree5"
              name="paymentTermsAgree5"
              :checked="terms[4].checked"
              @change="onCheckBoxChange($event, 4)"
            >
            <label for="paymentTermsAgree5" class="focus">TOSS 개인정보 제3자 제공 동의</label>
          </span>
          <a
            class="title"
            @click="openPopUp(4)"
          >
            자세히 보기
          </a>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import PopupTerms from "@/views/order/main/components/PopUpWrappers/PopupTerms";
import { mapGetters } from 'vuex';

export default {
  name: "OrderTerms",
  components: {
    PopupTerms
  },
  data() {
    return {
    //   toggleAccordion: false,
      termsId: 0,
      terms: [
        {
          id: 0,
          title: "전자상거래법",
          checked: false,
        },
        {
          id: 1,
          title: "개인정보 수집 및 이용에 대한 동의",
          checked: false,
        },
        {
          id: 2,
          title: "TOSS 개인정보 수집 이용 동의",
          checked: false,
        },
        {
          id: 3,
          title: "TOSS 전자금융거래 기본약관",
          checked: false,
        },
        {
          id: 4,
          title: "TOSS 개인정보 제3자 제공 동의",
          checked: false,
        },
      ],
    }
  },
  methods: {
    openPopUp(termsId = 0) {
      this.$emit("open-popup", {index: termsId, display: true});
    },

    toggleAll(event) {
      let checked = event.target.checked;
      this.terms = this.terms.map((clause) => {
        clause.checked = checked;
        return clause;
      });

      this.terms.map((clause, index) => {
        this.$store.commit("terms/updateCheckedWithIndex", {
          index: index,
          checked: clause.checked,
        });
      });
    },
    onCheckBoxChange(event, termsId = 0) {
      let checked = event.target.checked;
      this.$store.commit("terms/updateCheckedWithIndex", {
        index: termsId,
        checked: checked,
      });

      if (this.isTossTermsRequired) {
        this.$refs.totalRef.checked = !this.allTerms.includes(false);
      } else {
        this.$refs.totalRef.checked = !this.allTerms.slice(0, 2).includes(false);
      }
    }
  },
  props: {
    isTossTermsRequired: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters({
      allTerms: "terms/getAllTerms",
    }),
  },
  mounted() {
    this.terms[0].checked = this.allTerms[0];
    this.terms[1].checked = this.allTerms[1];
    this.terms[2].checked = this.allTerms[2];
    this.terms[3].checked = this.allTerms[3];
    this.terms[4].checked = this.allTerms[4];
    
    if (this.isTossTermsRequired) {
      this.$refs.totalRef.checked = !this.allTerms.includes(false);
    } else {
      this.$refs.totalRef.checked = !this.allTerms.slice(0, 2).includes(false);
    }
  },
}
</script>

<style scoped>

</style>
